import { createPortal } from "react-dom";
import { FC, ReactNode } from "react";
import { FiX } from "react-icons/fi";
import { UseToggleStateReturn } from "hooks/useToggleState";

const Modal: FC<{ children: ReactNode; toggle: UseToggleStateReturn; title?: ReactNode }> = ({ children, toggle, title }) => {
	return createPortal(
		<div
			className={`w-screen h-screen ${toggle.isToggled ? "" : "hidden"} flex fixed top-0 left-0 z-modal bg-black bg-opacity-90`}
			onClick={(e) => {
				e.stopPropagation();
				toggle.off();
			}}
		>
			<div
				className="max-h-[80vh] min-w-[256px] w-[60vw] overflow-y-auto bg-gray-primary rounded-lg absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2"
				onClick={(e) => {
					e.stopPropagation();
				}}
			>
				<div className="rounded-t-lg pl-4 pr-3 py-2 bg-gray-primary text-lg font-medium flex justify-between items-center">
					<span className="text-sm">{title}</span>
					<FiX className="text-gray-200 cursor-pointer" onClick={toggle.off} />
				</div>
				<div className="px-4 pb-4">{children}</div>
			</div>
		</div>,
		document.getElementById("modal") as HTMLDivElement
	);
};

export default Modal;
